module.exports = __webpack_public_path__ + "img/inspection@2x.ce940ad.webp";